import React from 'react';

class URLFormClass extends React.Component {
    constructor(props) {
        super(props);
        this.state={}
    }// end constructor

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.data !== nextProps.data
            || this.props.urlCount !== nextProps.urlCount
            || this.props.disabled !== nextProps.disabled
        )
    }

    render() {
        const { urlCount, setUrlValue, disabled, data } = this.props;
        return (
            <div className='row'>
                {urlCount.length !== 0 && urlCount.map((url) => (
                    <div className='col-lg-4' key={url}>
                        <label>URL 분석 {url}</label>
                        <input className='form-control'
                               type="text"
                               placeholder="URL 주소 입력"
                               name={`URL_${url}`}
                               onChange={(e) => setUrlValue(e.target.value, url-1)}
                               value={data[url-1] || ''}
                               disabled={disabled}
                        />
                    </div>
                ))}
            </div>
        )
    }
}// end class

export default URLFormClass;
